export default {"src":"/_next/static/media/EQT.e4f3787f.svg","height":18,"width":18};